export default "__VITE_ASSET__OYleIxFE__"